import { Fragment } from 'react';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import UILink from 'UIComponents/link/UILink';
import { Link } from 'foundations-components/transitional/components/Link';
import UITruncateMultiline from 'UIComponents/text/UITruncateMultiline';
import { TruncateMultiline } from 'foundations-components/transitional/components/TruncateMultiline';
import styled from 'foundations-theming/utils';
import { getHrefForAsset } from '../../utils/getHrefForAsset';
import { jsx as _jsx } from "react/jsx-runtime";
const EditorConditionLinkContainer = styled.div.withConfig({
  displayName: "EditorConditionLink__EditorConditionLinkContainer",
  componentId: "sc-7bjln8-0"
})(["word-break:break-word;"]);
const EditorConditionLink = ({
  condition,
  filterFamily,
  linkLabel
}) => {
  var _condition$field;
  const label = (_condition$field = condition.field) === null || _condition$field === void 0 ? void 0 : _condition$field.label;
  if (!label) {
    return null;
  }
  const href = getHrefForAsset(filterFamily, condition.field);
  if (linkLabel) {
    const link = href ? {
      external: true,
      href
    } : {};
    const truncate = {
      maxChars: 80,
      Paragraph: Fragment,
      text: label
    };
    return /*#__PURE__*/_jsx(EditorConditionLinkContainer, {
      children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
        elements: {
          Link: href ? Link : Fragment,
          Truncate: TruncateMultiline
        },
        message: linkLabel,
        options: {
          link,
          truncate
        }
      })
    });
  }
  const labelComponent = /*#__PURE__*/_jsx(UITruncateMultiline, {
    Paragraph: Fragment,
    maxChars: 80,
    text: label
  });
  if (href) {
    return /*#__PURE__*/_jsx(EditorConditionLinkContainer, {
      children: /*#__PURE__*/_jsx(UILink, {
        external: true,
        href: href,
        children: labelComponent
      })
    });
  }
  return /*#__PURE__*/_jsx(EditorConditionLinkContainer, {
    children: labelComponent
  });
};
export default EditorConditionLink;